<template>
  <div class="questionnaire">
    <FormDefault v-if="!isThisPhonemes" v-bind:questionTitle= "questTitle" v-bind:questions="questions" />
    <FormPhonemes v-else v-bind:questions="questions" />

    <router-link
      class="btn btn-light btn-lg btn-block"
      v-if="showBtn"
      v-bind:to="{ name: 'Results', params: { questResults: results, isPhonemes:isThisPhonemes } }"
      >{{ $t('results') }}</router-link
    >
  </div>
</template>

<i18n>
  {
  "el": {
  "results": "ΑΠΟΤΕΛΕΣΜΑΤΑ"
  },
  "en": {
  "results": "RESULTS"
  }
  }
</i18n>

<script>
import { mapState } from 'vuex'
import FormDefault from '@/components/QuestionnaireSingle/Forms/Default.vue'
import FormPhonemes from '@/components/QuestionnaireSingle/Forms/Phonemes.vue'
import Slugify from '@/lib/Slugify.js'

export default {
  name: 'QuestionnaireSingle',
  components: {
    FormDefault,
    FormPhonemes
  },
  data() {
    return {
      isThisPhonemes: false,
      questTitle: '',
      showBtn: false,
      questions: [],
      results: []
    }
  },
  computed: {
    ...mapState(['questData'])
  },
  mounted: function() {
    /**
     * TODO: DOCUMENT THIS
     * !SHOULD IMPROVE
     */
    this.$nextTick(function() {
      const _this = this
      const $questsObj = JSON.parse(JSON.stringify(_this.questData))
      const $ourSlug = _this.$route.params.quest

      // !BREAKS STUFF
      if (!$ourSlug) {
        this.$router.push('/')
      }

      if (_this.$route.params.quest === 'arthrosi-fonologia') {
        let phonLevel = _this.$route.params.questlevel || '0'

        _this.isThisPhonemes = true
        _this.questions = $questsObj[2].levels

        _this.questions.splice(++phonLevel, _this.questions.length)
      } else {
        Array.prototype.forEach.call($questsObj, function(item, index) {
          const itemSlug = Slugify.make(item.title)

          if (itemSlug === $ourSlug) {
            _this.questTitle = item.levels[0].subtitle
            _this.questions = item.levels[0].questions
          }
        })
      }
    })
  }
}
</script>
